import {
  ADD_BANK_SUCCESS,
  ADD_BANK_FAILED,
  ADD_BANK_INVALID_REQUEST,
  NETWORK_ERROR_ADD_BANK,
  LOADING_ADD_BANK,
  RESET_ADD_BANK,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  invalidRequest: false,
  data: {},
  networkError: ""
};

export default (state = initialState, action) => {
  switch (action.type) {

    case LOADING_ADD_BANK:
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: action.payload,
        networkError: ""
      };

    case ADD_BANK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
        networkError: ""
      };

    case ADD_BANK_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: action.payload,
        networkError: ""
      };

    case ADD_BANK_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: true,
        data: action.payload,
        networkError: ""
      };

    case NETWORK_ERROR_ADD_BANK:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        data: action.payload,
        networkError: "OOPS.... Something went wrong !"
      };


    case RESET_ADD_BANK:
      return (state = initialState);

    default:
      return state;
  }
};
